import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { PALLET_SUMMARY_LEVEL, PalletSummaryLevel } from "./constants";

const OVERVIEW_LABEL = "ภาพรวมทุกสาขา";

/** A crumb with a level to go back to is a link; the level on screen is plain text. */
function Crumb({ label, onClick }: Readonly<{ label: string; onClick?: () => void }>) {
  if (!onClick) return <Typography color="text.primary">{label}</Typography>;
  return (
    <Link component="button" underline="hover" onClick={onClick}>
      {label}
    </Link>
  );
}

interface PalletBreadcrumbsProps {
  level: PalletSummaryLevel;
  /** Only an all-branch reader has the every-branch level above their branch. */
  hasOverview: boolean;
  branchName: string;
  routeName: string;
  onOpenOverview: () => void;
  onOpenBranch: () => void;
}

/**
 * ภาพรวมทุกสาขา › {branch} › {route}, cut at the level on screen. A crumb with no text yet
 * (its name still loading, and no branch code to stand in for it) is left out rather than
 * drawn as an empty link.
 */
export default function PalletBreadcrumbs({
  level,
  hasOverview,
  branchName,
  routeName,
  onOpenOverview,
  onOpenBranch,
}: Readonly<PalletBreadcrumbsProps>) {
  const isOverview = level === PALLET_SUMMARY_LEVEL.overview;
  const isRoute = level === PALLET_SUMMARY_LEVEL.route;
  const showsBranch = !isOverview && branchName !== "";
  const showsRoute = isRoute && routeName !== "";
  const overviewAction = isOverview ? undefined : onOpenOverview;
  const branchAction = isRoute ? onOpenBranch : undefined;

  return (
    <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} sx={{ mb: 2 }}>
      {hasOverview && <Crumb label={OVERVIEW_LABEL} onClick={overviewAction} />}
      {showsBranch && <Crumb label={branchName} onClick={branchAction} />}
      {showsRoute && <Crumb label={routeName} />}
    </Breadcrumbs>
  );
}
